import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { downloadExcel, downloadSettingExcel } from "src/utils/blob/blobUtil";

import { SysCodeDto } from 'src/dtos/code/sysCodeDto';

import { defaultWMS1100_R01Filter, WMS1100_R01Filter, useWMS1100_R01Store } from 'src/containers/mes/WMS/WMS1100_R01/Store_WMS1100_R01';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import { Tab } from 'src/store/useUiuxStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { showError, showSuccess, ShowSuccessFetch, showWarning } from 'src/utils/toast/toastUtil';

import { downloadExcel_WMS1100_R01, getWMS1100_R01AllCount, getWMS1100_R01DetailList, getWMS1100_R01List, getWMS1100_R01LotList } from "./Api_WMS1100_R01";
import { defaultWMS1100_R01DetailDto, defaultWMS1100_R01HeaderDto, defaultWMS1100_R01LotDto, WMS1100_R01DetailDto, WMS1100_R01HeaderDto, WMS1100_R01LotDto } from './Dto_WMS1100_R01';
import { AgGridReact } from 'ag-grid-react';
import { fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler } from 'src/utils/grid/GridHandlerContent';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { validateString } from 'src/utils/string/stringUtil';
import { validateCustomCd, validateEmployeeCd } from 'src/utils/grid/GridValidateContent';
import { LabelPrintData } from 'src/apis/labelApi';
import { useQzPrint } from 'src/hooks/useQzPrint';
import useUserStore from 'src/store/useUserStore';


interface Props {
	gridRef: React.RefObject<AgGridReact<WMS1100_R01HeaderDto> | null>;
	lotGridRef: React.RefObject<AgGridReact<WMS1100_R01LotDto> | null>;
	detailGridRef: React.RefObject<AgGridReact<WMS1100_R01DetailDto> | null>;

	tabList: Tab[] | undefined;
	setMessage: (message: string) => void;

	containerRef: React.RefObject<HTMLDivElement | null>;
	isResizing: React.MutableRefObject<boolean>;
	
}

export const Content_WMS1100_R01 = (props: Props) => {
	const { printBulkLabel } = useQzPrint();

	const {
		gridRef, lotGridRef, detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	} = props;

	
	const {
		WMS1100_R01Filter, setWMS1100_R01Filter,
		WMS1100_R01PastFilter, setWMS1100_R01PastFilter,
		WMS1100_R01List, setWMS1100_R01List,
		selectedWMS1100_R01, setSelectedWMS1100_R01, 
		selectedWMS1100_R01DetailList, setSelectedWMS1100_R01DetailList,
		WMS1100_R01DetailList, setWMS1100_R01DetailList,
		originalWMS1100_R01DetailList, setOriginalWMS1100_R01DetailList,
		WMS1100_R01LotList, setWMS1100_R01LotList,
		selectedWMS1100_R01LotList, setSelectedWMS1100_R01LotList,
		originalWMS1100_R01LotList, setOriginalWMS1100_R01LotList, 
		allCount, setAllCount,
		fetchLotTrigger, setFetchLotTrigger,
		initData,
		setScrollTop, setDetailScrollTop, setLotScrollTop,
	} = useWMS1100_R01Store();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { inoutClassList, inoutMethodList, wmsCdList, wmsInTypeCdList, yesNoList, compCdList, customCdList, employeeCdList, warehouseCdList, } = useCommonCodeStore();
	const { company, userInfo } = useUserStore();

	useFetchActionbarAuth("WMS1100_R01");

	
	const prevWmsOrderNoRef = useRef<string | undefined>(undefined);
	
	const handleExcelClick = useCallback(async () => {
		if (!selectedWMS1100_R01) {
			showWarning("선택된 입고정보내역이 없습니다.");
			return;
		}
		setLoadingSpinner(true);

		const response = await downloadExcel_WMS1100_R01('', selectedWMS1100_R01.transportNo, WMS1100_R01List.length ?? 0);

		downloadSettingExcel({ responseData: response.data.data, fileName: '입고정보 등록-excel.xlsx' });

		setLoadingSpinner(false);
	}, [selectedWMS1100_R01])

	const getParams = (filter: WMS1100_R01Filter) => {
		const params: Partial<WMS1100_R01Filter> = {
			dateRange: filter.dateRange || undefined,
			customCd: filter.customCd || undefined,
		};
		return params;
	}

	const renewalAllCount = useCallback(async () => {
		const response = await getWMS1100_R01AllCount(getParams(WMS1100_R01Filter));
		setAllCount(response.data.data);
		return response.data.data;
	}, [WMS1100_R01Filter, setAllCount]);

	const fetchData = useCallback(async () => {
		setLoadingSpinner(true);
		setScrollTop(null);
		setDetailScrollTop(null);
		setLotScrollTop(null);
	
		const responseData = (await getWMS1100_R01List(
			'',
			getParams(WMS1100_R01Filter),
			WMS1100_R01List.length ?? 0
		));

		let newList = [...responseData.data.data ] as WMS1100_R01HeaderDto[];
		setWMS1100_R01List(newList);

		const processAllCount = await renewalAllCount();
		if (newList && newList.length > 0) {
			gridRefSelectedRowHandler(
				gridRef,
				setSelectedWMS1100_R01,
				() => true,
			);
			setWMS1100_R01PastFilter(WMS1100_R01Filter);
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
			setTimeout(() => setMessage(""), 5000);
		}else {
			showWarning('데이터가 없습니다.');
			setSelectedWMS1100_R01(defaultWMS1100_R01HeaderDto);
			setWMS1100_R01List([]);
			setWMS1100_R01DetailList([]); 
			setSelectedWMS1100_R01DetailList([]);
			setOriginalWMS1100_R01DetailList([]);
		}
		setLoadingSpinner(false);
		return responseData;
	}, [WMS1100_R01Filter, WMS1100_R01List, setWMS1100_R01List, setWMS1100_R01PastFilter, setSelectedWMS1100_R01, selectedWMS1100_R01, setScrollTop, setDetailScrollTop, setLotScrollTop])
	

	const defaultWMS1100_R01HeaderRow = useCallback(() => {

		const logicCenterCd = wmsCdList[0].minorCd;

		return {
			...defaultWMS1100_R01HeaderDto,
			compCd: compCdList[0].compCd,
			inoutClass: '110', // 입고구분값 110으로 고정(구매입고)
			logicCenter: logicCenterCd,
			warehouseCd: warehouseCdList[0].warehouseCd,
			inoutMethod: inoutMethodList[0].minorCd,
			inoutType: inoutClassList[0].minorCd,
			inserted: true,
		}
	}, [defaultWMS1100_R01HeaderDto, compCdList, wmsCdList, warehouseCdList, inoutMethodList, inoutClassList]);

	const defaultWMS1100_R01DetailRow = useCallback(() => {
		return {
			...defaultWMS1100_R01DetailDto,
			inserted: true,
		}
	}, [defaultWMS1100_R01DetailDto]);

	const defaultWMS1100_R01LotRow = useCallback(() => {
		return {
			...defaultWMS1100_R01LotDto,
			lotInputOption: 'N', // 로트입력여부 값 고정(N: 입력안함)
			inserted: true,
		}
	}, [defaultWMS1100_R01LotDto]);
	
	const initContainerData = useCallback(() => {
		initData();
	}, [selectedWMS1100_R01])

	const handleDeleteClick = useCallback(() => {

	}, [selectedWMS1100_R01]);
	
	const handleCreateClick = () => {
		setSelectedWMS1100_R01(undefined);
		setWMS1100_R01DetailList([{...defaultWMS1100_R01DetailRow(), inserted: true}]);
		setSelectedWMS1100_R01DetailList([]);
		setOriginalWMS1100_R01DetailList([]);
	}

	const handleSaveClick = useCallback(async () => {

		setTimeout(() => {
			setMessage('');
		}, 5000)
	}, []);
	
	const handleFetchDetailList = useCallback(async (transportCode: string) => {
		try {
			const detailResponse = await getWMS1100_R01DetailList(transportCode);
			const detailData = detailResponse.data.data;

			if (detailData && detailData.length > 0) {
				const currentDetailList = useWMS1100_R01Store.getState().WMS1100_R01DetailList;

				const existingItemsMap = new Map<string, WMS1100_R01DetailDto>();
				currentDetailList.forEach(item => {
					if (item.itemCd && item.itemStatus) {
						const key = `${item.itemCd}-${item.itemStatus}`;
						existingItemsMap.set(key, item);
					}
				});

				const updatedDetails = detailData.map((value: WMS1100_R01DetailDto) => {
					return {
						...value,
						valueIndex: value.valueIndex,
						orderIndex: value.orderIndex,
						orderIndexSeq: value.orderIndexSeq,
					}
				});
				setWMS1100_R01DetailList(updatedDetails);
				setOriginalWMS1100_R01DetailList(detailData);
				setMessage(`${selectedWMS1100_R01?.compNm}의 입고지시내역 ${detailData.length}건을 조회하였습니다.`);
				setTimeout(() => setMessage(""), 5000);

				setSelectedWMS1100_R01DetailList([1 as any]);
				setFetchLotTrigger(true); // lot 순회조회 시작
			} else {
				showError('상세내역이 없습니다.');
				setWMS1100_R01DetailList([]);
			}
		} catch (error) {
			console.error("상세 내역 조회 실패:", error);
			showError('상세 내역을 조회하는 중 오류가 발생했습니다.');
			setWMS1100_R01DetailList([]);
		}
	}, [
		setMessage, 
		setWMS1100_R01DetailList,
		setOriginalWMS1100_R01DetailList,
		selectedWMS1100_R01?.compNm,
		setFetchLotTrigger
	]);

	const handleFetchLotList = useCallback(async (
		transportNo: string, itemCd: string
	) => {
		if (!transportNo || !itemCd) {
			showWarning('해당 입고내역의 주문내역 데이터의 상태가 불분명합니다.');
			setWMS1100_R01LotList([]);
			setOriginalWMS1100_R01LotList([]);
			return;
		}

		const response = await getWMS1100_R01LotList(transportNo, itemCd);
		const lotData = response.data.data;
		if (lotData && lotData.length > 0) {
			setWMS1100_R01LotList(lotData);
			setOriginalWMS1100_R01LotList(lotData);
		} else {
			setWMS1100_R01LotList([]);
			setOriginalWMS1100_R01LotList([]);
		}

	}, [
		WMS1100_R01DetailList, selectedWMS1100_R01DetailList,
		setWMS1100_R01LotList,
		fetchLotTrigger, setFetchLotTrigger,
		setOriginalWMS1100_R01LotList,
	]);



	useEffect(() => {

		const fetchAllDetailsForSelectedRow = async () => {
			// console.log('selectedWMS1100_R01 :', selectedWMS1100_R01);
			if (!selectedWMS1100_R01 || !selectedWMS1100_R01.transportCode) {
				if (!selectedWMS1100_R01) {
					setWMS1100_R01DetailList([]);
					setOriginalWMS1100_R01DetailList([]);
					setWMS1100_R01LotList([]);
					setOriginalWMS1100_R01LotList([]);
				}
				prevWmsOrderNoRef.current = undefined; // 이전 선택 초기화
				return;
			}

			// 출하일자, 사업장, 상호를 조합한 값을 통해 상세 내역 조회
			handleFetchDetailList(selectedWMS1100_R01.transportCode);
			// 이전
			prevWmsOrderNoRef.current = selectedWMS1100_R01.transportNo;
		};

		fetchAllDetailsForSelectedRow();
	}, [selectedWMS1100_R01]);

	// WMS1100_R01DetailList 불러올때마다 각각 품목의 lot 정보를 다 불러오기
	useEffect(() => {
		console.log('fetchLotTrigger :', fetchLotTrigger);
		if (fetchLotTrigger) {
			if ( selectedWMS1100_R01DetailList.length > 0) {
				const selectedTransportNo = WMS1100_R01DetailList.find(
					value => value.valueIndex === selectedWMS1100_R01DetailList[0] as any
				)?.transportNo || '';
				const selectedItemCd = WMS1100_R01DetailList.find(
					value => value.valueIndex === selectedWMS1100_R01DetailList[0] as any
				)?.itemCd || '';

				handleFetchLotList(selectedTransportNo, selectedItemCd);
			} else {
				setWMS1100_R01LotList([]);
				setOriginalWMS1100_R01LotList([]);
			}
			setFetchLotTrigger(false);
		}
	}, [
		fetchLotTrigger, setFetchLotTrigger, 
		selectedWMS1100_R01, WMS1100_R01DetailList, setWMS1100_R01LotList, setOriginalWMS1100_R01LotList
	]);


	
	
	return {
		handleExcelClick,
		fetchData,
		defaultWMS1100_R01HeaderRow,
		defaultWMS1100_R01DetailRow,
		defaultWMS1100_R01LotRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
		handleFetchDetailList,
	};
}
